import { render, staticRenderFns } from "./AdditionalFieldPage.vue?vue&type=template&id=478c7266&"
import script from "./AdditionalFieldPage.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports